enum ApnStrings {
	VODAFONE_APN = 'spe.inetd.gdsp',
	HOLOGRAM_APN = 'hologram',
	ONOMONDO_APN = 'onomondo',
}

export function getApnDisplayName(apn: ApnStrings) {
	switch (apn) {
		case ApnStrings.VODAFONE_APN:
			return 'Vodafone';
		case ApnStrings.HOLOGRAM_APN:
			return 'Hologram';
		case ApnStrings.ONOMONDO_APN:
			return 'Onomondo';
		default:
			return '';
	}
}
